export default "__VITE_ASSET__CEGsz2PM__"